import "./index.css";
import rustLogo from "./assets/rust-white.svg";
import angularLogo from "./assets/angular.svg";
import reactLogo from "./assets/react.svg";
import computerImage from './computer_70s.png';
import TextEffect from "./textEffectTopLeft";
import TextEffectTopLeft from "./textEffectTopLeft";
import TextEffectBottomLeft from "./textEffectBottomLeft";

export function App() {
  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <div className="flex flex-col">
        <div className="flex flex-row items-center">
          <div className="flex flex-col">
            <div className="flex flex-row px-4 items-center">
              <div className="flex flex-col mr-6 shared-hover-container items-end">
                <TextEffectTopLeft text={"Daniel"}></TextEffectTopLeft>
                <TextEffectBottomLeft text={"Stoklosa"}></TextEffectBottomLeft>
              </div>
              <div className="self-stretch w-2 bg-[var(--color-mustard)] rounded-l-lg"></div>
              <div className="self-stretch w-2 bg-[var(--color-burnt)]"></div>
              <div className="self-stretch w-2 bg-[var(--color-redorange)]"></div>
              <div className="flex flex-col gap-2 text-[var(--color-beige)] bg-[var(--color-coffee)] border-[var(--color-mustard)] rounded-r-lg">

                <div className="p-2">
                  <div className="flex flex-row items-center gap-2">
                    <span className="material-icons">school</span>
                    <p className="text-2xl font-bold">Bachelor of Computer Science</p>
                  </div>
                  <a className="wobble-button italic text-lg font-semibold hover:bg-white hover:rounded hover:text-[var(--color-coffee)] hover:px-2 px-2" href="https://h-da.de/studium/studienangebot/studiengaenge/information-science-und-informatik/informatik-dual-kosi-bsc" target="_blank" rel="noopener noreferrer">@ Hochschule Darmstadt</a>
                  <p className="font-medium px-2">2023 - 2027</p>
                </div>



                <div className="p-2">
                  <div className="flex flex-row items-center gap-2">
                    <span className="material-icons">work</span>
                    <p className="text-2xl font-bold">Junior Consultant Java Backend</p>
                  </div>
                  <a className="wobble-button italic text-lg font-semibold hover:bg-white hover:rounded hover:text-[var(--color-coffee)] hover:px-2 px-2" href="https://www.hyand.com/" target="_blank" rel="noopener noreferrer">@ Hyand</a>
                  <p className="font-medium px-2">Since 2023</p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end p-2">
          <img src={rustLogo} alt="Rust" className="h-15 w-15 hover:h-20 hover:w-20 inline" />
          <img src={angularLogo} alt="Angular" className="h-15 w-15 hover:h-20 hover:w-20 inline" />
          <img src={reactLogo} alt="React" className="h-15 w-15 hover:h-20 hover:w-20 inline" />
        </div>
      </div>
    </div>
  );
}

export default App;



            {/* <div className="flex flex-row bg-[var(--color-coffee)] p-4">
              <div className="flex flex-col text-black gap-1">
                <p className="text-2xl font-bold">Technologies</p>
                <div className="flex flex-col text-2xl font-bold gap-1">
                  <button className="flex flex-row items-center border-2 border-[var(--color-mustard)] bg-[var(--color-mustard)] bg rounded p-1">
                    <img src={rustLogo} alt="Rust" className="w-6 h-6 inline mr-2" />
                    <p>Rust</p>
                  </button>
                  <button className="flex flex-row items-center bg-[var(--color-redorange)] rounded p-1">
                    <img src={angularLogo} alt="Angular" className="w-6 h-6 inline mr-2" />
                    <p>Angular</p>
                  </button>
                  <button className="flex flex-row items-center bg-[var(--color-redorange)] rounded p-1">
                    <img src={reactLogo} alt="React" className="w-6 h-6 inline mr-2" />
                    <p>React</p>
                  </button>
                </div>
              </div>
            </div> */}